// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { connectFunctionsEmulator, getFunctions } from "firebase/functions"
import config from "../config.json"

const firebaseConfig = {
  apiKey: "AIzaSyCXnMHyhHz8anRhtKjc3Eq_dC7UfP1Fk-w",
  authDomain: "wecar-rideshare.firebaseapp.com",
  projectId: "wecar-rideshare",
  storageBucket: "wecar-rideshare.appspot.com",
  messagingSenderId: "707577220280",
  appId: "1:707577220280:web:5aeda1e81a13880b0f384d",
  measurementId: "G-XW2H9QTH0J"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
const auth = getAuth(app)
const firestore = getFirestore(app, config.environment)
const functions = getFunctions(app, "europe-west1")

if(config.useFunctionsEmulator) {
  connectFunctionsEmulator(functions, "localhost", 5001)
}

export {
  analytics,
  auth,
  firestore,
  functions
}